
import { Component, OnInit, Input, ViewChild, AfterViewInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ValoresActualesComponent } from './valores-actuales/valores-actuales.component';

import { SharedService } from 'app/modules/common/services/shared-service';
import { ConfirmDialogModel } from 'app/modules/common/components/confirmation-dialog/confirm-dialog-model';
import { ConfirmationDialogComponent } from 'app/modules/common/components/confirmation-dialog/confirmation-dialog.component';
import { CompanyViewDetailComponent } from 'app/modules/company-view/company-view-detail/company-view-detail.component'
import { Subscription } from 'rxjs'
import { AtributosService } from '../../services/atributos.service';
import { CompanyManagementViewService } from '../../services/company-management-view.service';
import { CompanySideBarTreeViewService } from '../../services/company-side-bar-tree-view.service';
import { PageLoaderService } from 'app/modules/common/services/page-loader.service'
import Utils from 'app/Utils';
@Component({
    selector: 'app-atributos',
    templateUrl: './atributos.component.html',
    styleUrls: ['./atributos.component.scss'],
    standalone: false
})

export class AtributosComponent implements OnInit, AfterViewInit {
  @ViewChild(CompanyViewDetailComponent) child;
  @Input() companyId : any

  permissionList: Array<string>;
  displayedColumns: string[] = ['position', 'option'];
  headerAttributosChecked = false;
  selectedCompanyId;
  dataSourceHeaderAtributos;
  dataSourceValoresActuales;
  selecttedAtributo;
  selecttedAtributoText;
  selectedTipo;
  selectedDeLocaalizacion = '0'
  public editPremit = false;
  editProcess: boolean = true;
  valoresActualesPermit = false;
  permit5: number;
  updateval: boolean = false;
  CalcularAbsentismo;
  AtributoObligatorio;
  CoincidirconLista;
  MultipleconJornada;
  clickEventSubscription: Subscription;
  clickEventSubscriptionFromTreeNode: Subscription;
  updatedString: string;
  attributoValue;
  popupHide:boolean=false;
  public isLoading: boolean = true
  public isLoadingVal: boolean = true

  constructor(
    private _dialog: MatDialog,
    private _atributosService: AtributosService,
    private _sharedService: SharedService,
    public _companyManagementViewService: CompanyManagementViewService,
    public _companySideBarTreeViewService: CompanySideBarTreeViewService,
    private _pageLoaderService: PageLoaderService,

  ) {

  }


  ngOnInit(): void {    
    this.selectedCompanyId = this.companyId     
    this.initializeAttributeTab()
    this.clearView(this.selectedCompanyId);
    this.permissionList = Utils.decrypt(localStorage.getItem('permissionIds')).split(',');
    this.permit5 = this.permissionList.indexOf('5');
    if (this.permit5 != -1) {
      this.valoresActualesPermit = true;
    }
  }

  public initializeAttributeTab(){
    this.getAttributoEmpresaForAttributoTab(this.selectedCompanyId);
    this.checkHeaderAtributoStatus(this.selectedCompanyId)
    this.checkHeaderLocalizacionStatus(this.selectedCompanyId)
  }

  ngAfterViewInit(): void {
    if (this.child) {
      this.editPremit = this.child.editPremit;
    }
    if (!this.editPremit) {
      this.editProcess = false;
    }
  }
  receiveMessages($event) {
    this.editPremit = $event;
    if (this.permit5 != -1) {
      this.valoresActualesPermit = true;
    }
  }

  public createvaloresactuales(): void {
    if(!this.popupHide)
    {
      const dialogRef = this._dialog.open(ValoresActualesComponent, {
        data: { isinsert: true, tipo: this.selectedTipo, empresaid: this.selectedCompanyId },
        autoFocus: false
      });
      dialogRef.afterClosed().subscribe(res => {
        //Refresh ValoresActuales
        this.getValoresActuales(this.selectedCompanyId, this.selectedTipo);
      });
    }
   
   
  }
  public editvaloresactuales(element): void {
    const dialogRef = this._dialog.open(ValoresActualesComponent, {
      data: { element }
    });
    dialogRef.afterClosed().subscribe(res => {
      //Refresh ValoresActuales
      this.getValoresActuales(this.selectedCompanyId, this.selectedTipo);
    });
  }
  public deletevaloresactuales(element: any) {
    const dialogData = new ConfirmDialogModel('¿Eliminar valor del atributo?', '');
    const dialogRef = this._dialog.open(ConfirmationDialogComponent, {
      data: dialogData
    });
    dialogRef.afterClosed().subscribe(response => {
      if (response) {
        this._atributosService.DeleteValoresActuales(element.atributoId).subscribe(result => {
          if (result) {
            this.getValoresActuales(this.selectedCompanyId, this.selectedTipo);
          } else {
            //this._sharedService.ShowSnackBar('Error deleting Valores actuales', 'Okay', 2000);
          }
        }, err => {
          console.error(err);
          this._sharedService.ShowSnackBar('API solicitud fallida', 'Okay', 2000);
        });
      }
    }
    )
  }

  public updateAttributos() {
    if (this.headerAttributosChecked) {
      this.updatedString = "S";
    } else {
      this.updatedString = "N";
      this.editProcess = false;
    }  

    this.updateHeaderAtributosName(this.selectedCompanyId, this.selectedTipo, this.attributoValue);
    this.updateHeaderAtributos(this.selectedCompanyId, this.updatedString);
    this.updateLocalization(this.selectedCompanyId, this.selectedDeLocaalizacion, this.updatedString);
    this.updateRightSideCheckBoxes(this.selectedCompanyId, this.selectedTipo, this.CalcularAbsentismo, this.AtributoObligatorio, this.CoincidirconLista, this.MultipleconJornada);
    this.attributoValue="";
    
  }

  clearView(EmpresaId: any) {
    if (EmpresaId == 0) {
      this.dataSourceHeaderAtributos = null;
      this.dataSourceValoresActuales = null;
      this.selectedDeLocaalizacion = null;
      this.CalcularAbsentismo = null;
      this.AtributoObligatorio = null;
      this.CoincidirconLista = null;
      this.MultipleconJornada = null;
      this.selecttedAtributo = null;
    }
  }

  onBlurNombre(value) {
    this.attributoValue=value;
    this.popupHide=false;
  }

  onFocusEvent(event)
  {
    this.popupHide=true;
  }


  private checkHeaderAtributoStatus(EmpresaId: any) {
    if (this.selectedCompanyId > 0) {
      this._atributosService.CheckHeaderAtributoStatus(EmpresaId)
        .subscribe(res => {
          this.headerAttributosChecked = res.result;
          this.editProcess = !res.result;
        });
    }
  }

  private checkHeaderLocalizacionStatus(EmpresaId: any) {
    if (this.selectedCompanyId > 0) {
      this._atributosService.CheckHeaderLocalizacionStatus(EmpresaId)
        .subscribe(res => {
          this.selectedDeLocaalizacion = res.result;
        });
    }
  }

  private getAttributoEmpresaForAttributoTab(EmpresaId: any) {
    if (this.selectedCompanyId > 0) {
      this.isLoading=true;
      this.isLoadingVal=true;
      this._atributosService.GetAttributoEmpresa(EmpresaId)
        .subscribe(res => {
          if (res.result) {
            this.isLoading=false;
            this.dataSourceHeaderAtributos = res.result;
            this.loadValoresActuales(1, res.result[0].attributoName, 1)
            
          }
        });
    }else
    {
      this.isLoading=false;
    }

  }

  public loadValoresActuales(Tipo: any, Text: any, Define: any) {    
    if (Text != null && Define == 1) {
      this.selecttedAtributo = Text;
      this.attributoValue=Text;
    }
    else {
      this.selecttedAtributo = null;
    }
    this.getValoresActuales(this.selectedCompanyId, Tipo);
    this.dataBindToAtributosCheckBoxes(this.selectedCompanyId, Tipo)
  }

  private getValoresActuales(EmpresaId: any, Tipo: any) {
    this.isLoadingVal=true;
    this.selectedTipo = Tipo;
    this._atributosService.GetValoresActuales(EmpresaId, Tipo)
      .subscribe(res => {
        this.isLoadingVal=false;
        this.dataSourceValoresActuales = res.result;
      });
  }

  private dataBindToAtributosCheckBoxes(EmpresaId: any, Tipo: any) {
    if (this.selectedCompanyId > 0) {
      this._atributosService.DataBindToAtributosCheckBoxes(EmpresaId, Tipo)
        .subscribe(res => {
          this.CalcularAbsentismo = res.result.calcularAbsentismo;
          this.AtributoObligatorio = res.result.atributoObligatorio;
          this.CoincidirconLista = res.result.coincidirconLista;
          this.MultipleconJornada = res.result.multipleconJornada;
        });
    }
  }

  private updateHeaderAtributos(EmpresaId: any, updatedstring: any) {
    if (this.selectedCompanyId > 0) {
      this._atributosService.UpdateHeaderAtributos(EmpresaId, updatedstring)
        .subscribe(res => {
          if (res) {
            this.updateval = true;
          }
          this.checkHeaderAtributoStatus(this.selectedCompanyId);
          this.getAttributoEmpresaForAttributoTab(this.selectedCompanyId);
          this.checkHeaderLocalizacionStatus(this.selectedCompanyId);
        });
    }
  }

  private updateHeaderAtributosName(EmpresaId: any, typo: any, attributoname: string | null) {
    if (this.selectedCompanyId > 0) {
      if (!attributoname || attributoname.trim() === '') {
        attributoname = null;
      }
      this._atributosService.UpdateHeaderAtributosName(EmpresaId, typo, attributoname)
        .subscribe(res => {
          this.getAttributoEmpresaForAttributoTab(this.selectedCompanyId);
        });
    }
  }

  private updateLocalization(EmpresaId: any, localizationid: any, headerstatus: any) {
    if (this.selectedCompanyId > 0) {
      this._atributosService.UpdateLocalization(EmpresaId, localizationid, headerstatus)
        .subscribe(res => {
          //
        });
    }
  }

  private updateRightSideCheckBoxes(id: any, tipo: any, calcularabsentismo: boolean, atributoobligatorio: boolean, coincidirconlista: boolean, multipleconjornada: boolean) {
    if (this.selectedCompanyId > 0) {
      this._atributosService.UpdateRightSideCheckBoxes(id, tipo, calcularabsentismo, atributoobligatorio, coincidirconlista, multipleconjornada)
        .subscribe(res => {
          //
        });
    }
  }

}
